import { showEventSelectorPopup } from "@client/actions";
import { type RootContainerProps } from "@client/content/types";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import { eventIdSelector } from "../selectors";
import { fetchPage } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector } from "./selectors";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      eventId: eventIdSelector(state),
      isEditMode: state.isEditMode,
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onEventRequired: () => dispatch(showEventSelectorPopup(true)),
  fetchPage: (page: number) => dispatch(fetchPage({ id: props.id, source: props.source, page }))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
